<meta content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      name="viewport"/>
<div *ngIf="room"
     [style]="{ width: getWidth(), height: getHeight() }"
     class="view-web"
     id="main-container">

    <div class="header">
        <span class="room-title">{{room.title}}</span>
    </div>
    <div class="room-information">
        <div class="room-logo">
            <mat-icon *ngIf="!room.logoUrl" class="shop-icon">shop</mat-icon>
            <img *ngIf="room.logoUrl" [src]="room.logoUrl" alt="" class="logo-image"/>
        </div>
        <div class="room-viewer">
            <div *ngIf="room.shopName" class="room-shopName">{{room.shopName}}</div>
            <div class="group-num-view">
                <mat-icon class="view-num-icon-mobile">visibility</mat-icon>
                <span class="room-num-view">{{ viewAmount || 0 }}</span>
            </div>
        </div>
    </div>

    <div class="room-product-highlight">
        <div *ngIf="promotedProduct">
            <a *ngIf="promotedProduct.link" [href]="promotedProduct.link" alt="productName">
                <img [src]="promotedProduct.imageUrl" alt="" class="img-product-highlight"/>
                <span class="price-product-highlight">{{promotedProduct.sellingPrice}}</span>
            </a>
            <div *ngIf="!promotedProduct.link">
                <img [src]="promotedProduct.imageUrl" alt="" class="img-product-highlight"/>
                <span class="price-product-highlight">{{promotedProduct.sellingPrice}}</span>
            </div>
        </div>
    </div>

    <div class="view-video">
        <d-player
                [style]="{ width: getWidth(), height: getHeight() }"
                [video]="{url: room.hlsUrl}"
                autoplay="true"
                dpHls
                live="true"></d-player>
    </div>

    <div class="bottom">
        <button (click)="toggleShowProducts()" class="view-product">
            <img alt="" class="view-shopping-logo" src="assets/img/Shopping_bag.png"/>
        </button>
        <div *ngIf="showProducts && room.products">
            <app-product-list (onProductClosed)="toggleShowProducts()" [products]="room.products"></app-product-list>
        </div>
        <app-live-message (viewAmountToViewer)="getViewAmount($event)" [channelId]="room.chatId"
                          [displayName]="displayName" [userId]="userId"></app-live-message>
    </div>
</div>
